<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="vx-row">
    <div class="vx-col md:w-1/2 w-full mb-base">
      <vx-card title="User Profile">
        <div class="vx-row mb-2">
          <div class="vx-col w-full">
            <!-- NAME -->
            <vs-input label="Name/名字*" @keyup="uppercase" v-model="name" class="w-full" name="name" />
          </div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col w-full">
            <!-- Contact 1 -->
            <vs-input label="Contact No/电话号码*" v-model="primary_contact" class="w-full" name="primary_contact" />
          </div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col w-full">
            <!-- Contact 2 -->
            <vs-input label="Other Contact No/其他电话号码" v-model="secondary_contact" class="w-full" name="secondary_contact" />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <!-- Email -->
            <vs-input label="Email/电邮" v-model="email" class="w-full" name="email" />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <!-- Remark -->
            <vs-textarea label="Remark/备忘录" v-model="remark" class="mt-5 w-full" />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button class="mr-3 mb-2" :disabled="flag_submit" @click="update">Update</vs-button>
            <!-- <vs-button color="warning" type="border" class="mb-2" @click="input17 = input18 = input19 = input20 = ''; check5 = false;">Cancle</vs-button> -->
          </div>
        </div>
      </vx-card>
    </div>
    <div class="vx-col md:w-1/2 w-full mb-base">
      <vx-card title="Change Password">
        <div class="vx-row mb-2">
          <div class="vx-col w-full">
            <vs-input class="w-full" type="password" label-placeholder="Old Password/旧密码" v-model="password.old" />
          </div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col w-full">
            <vs-input class="w-full" type="password" label-placeholder="New Password/新密码" v-model="password.new_pass" />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button class="mr-3 mb-2" :disabled="flag_password" @click="updatePassword">Submit</vs-button>
            <!-- <vs-button color="warning" type="border" class="mb-2" @click="input17 = input18 = input19 = input20 = ''; check5 = false;">Cancle</vs-button> -->
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
// import flatPickr from 'vue-flatpickr-component';
// import 'flatpickr/dist/flatpickr.css';
// import jsPDF from 'jspdf' 
// import autoTable from 'jspdf-autotable'
// import {sample} from './sample.js'
// import DataViewSidebar from './sidebar.vue'
// // Store Module
// import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'

export default {
  name: 'Profile',
  components: {
    // DataViewSidebar
    // flatPickr
  },
  data () {
    return {
      name:'',
      primary_contact:'',
      secondary_contact:'',
      email:'',
      remark:'',
      password:{
        old:'',
        new_pass:''
      }
      // Get more form https://flatpickr.js.org/options/
      // config: {
      //     wrap: false, // set wrap to true only when using 'input-group'
      //     dateFormat: 'Y-m-d',
      //     mode: "range",
      // },
      // sample: sample,
      // date_range: '2021-12-01 to 2022-04-10',
      // report_list: [],
      // activePrompt2: false
    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    user_info(){
      let data = JSON.parse(sessionStorage.getItem('userInfo'));
      return data
    },
    flag_submit(){
      if(this.name == '' || this.primary_contact == '' ){
        return true
      }
      else
        return false
    },
    flag_password(){
      if(this.password.old == '' || this.password.new_pass == ''){
        return true
      }
      else
        return false
    },
    permissions () {
      if(this.$store.state.AppActiveUser && this.$store.state.AppActiveUser.permissions){
        return this.$store.state.AppActiveUser.permissions;
      }
      else{
        return []
      }
    },
    permissions_list(){
      if(this.permissions.includes('*') || this.permissions.includes('042')){
        return true
      }
      else{
        return false
      }
    }
  },
  methods: {
    uppercase() {
      this.name = this.name.toUpperCase();
    },
    update(){
      let self = this
      const baseURI = 'users/'+self.user_info.id
      let formData = new FormData();          
      formData.append('_method', 'PUT' )
      formData.append('name', self.name )
      formData.append('primary_contact', self.primary_contact )
      formData.append('secondary_contact', self.secondary_contact )
      formData.append('email', self.email )
      formData.append('remark', self.remark )
      self.$vs.loading()
      self.$http.post(baseURI,formData)
      .then((result) => {
        if(result.data.status == 'success'){
          self.$vs.loading.close()
          self.$vs.notify({
            color: 'success',
            title: 'User Profile',
            text: 'User Profile successfully updated'
          })

          self.$store.state.AppActiveUser.name = self.name 
          self.$store.state.AppActiveUser.primary_contact = self.primary_contact
          self.$store.state.AppActiveUser.secondary_contact = self.secondary_contact
          self.$store.state.AppActiveUser.email = self.email
          self.$store.state.AppActiveUser.remark = self.remark
        }
      })
    },
    updatePassword(){
      let self = this
      if(!this.flag_password){
        const baseURI = 'profiles/change_password'
        let formData = new FormData();          
        formData.append('id', self.user_info.id )
        formData.append('new_password', self.password.new_pass )
        formData.append('old_password', self.password.old )

        self.$vs.loading()
        self.$http.post(baseURI,formData)
        .then((result) => {
          if(result.data.status == 'success'){
            self.$vs.loading.close()

            self.$vs.notify({
              color: 'success',
              title: 'Password',
              text: 'Password successfully updated'
            })
            self.password = {
              old: '',
              new_pass: '',
            }
          }
          else{
            self.$vs.loading.close()
            self.$vs.notify({
              color: 'danger',
              title: 'Password',
              text: 'Invalid old password'
            })
          }
        })
      }
    },
    init(){
      let self = this

      self.name = self.$store.state.AppActiveUser.name
      self.primary_contact = self.$store.state.AppActiveUser.primary_contact
      self.secondary_contact = self.$store.state.AppActiveUser.secondary_contact
      self.email = self.$store.state.AppActiveUser.email
      self.remark = self.$store.state.AppActiveUser.remark
    }
  },
  created () {
    this.init()
  },
  mounted () {
  }
}
</script>

<style lang="scss">
#my-table{
  border-collapse: collapse;
  width: 100%;
  th,td{
    border: 1px solid #ddd;
    padding: 8px;
  }

  thead{
    font-weight:bold;
  }
}
</style>
